import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ITableConfig } from '../../../../../../../../projects/common/src/app/interfaces/table/table-config';
import { TableConfigService } from '../../../../../../../../projects/common/src/app/services/table/table-config.service';
import { ITableHeaderParams } from '../../../../../../../../projects/common/src/app/interfaces/table/table-header-params';
import { ITableDataParams } from '../../../../../../../../projects/common/src/app/interfaces/table/table-data-params';
import { PermissionService } from 'src/app/modules/core/services/parameter/permission/permission.service';
import { EPermissions } from 'projects/common/src/app/enumerables/permissions';

@Component({
  selector: 'app-prod-by-extraction-point-table',
  templateUrl: './prod-by-extraction-point-table.component.html',
  styleUrls: ['./prod-by-extraction-point-table.component.scss'],
})
export class ProdByExtractionPointTableComponent implements OnChanges {
  @Input() public data: any[];
  public tableConfig: ITableConfig;
  public readonly PERMISSION_OBJECT = 'LEY DE MINERAL';
  public canVisualize = false;

  constructor(private tableConfigService: TableConfigService, private permissionService: PermissionService) {}

  /**
   * Changes component
   *
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.setTableConfig(changes.data.currentValue);
  }

  /**
   * Function to set table configuration
   */
  private setTableConfig(tableData: any): void {
    const permissions = this.permissionService.getPermissionsByObj(this.PERMISSION_OBJECT);
    this.canVisualize = permissions.some(({ permission }) => permission.toLowerCase() === EPermissions.VISUALIZE.toLowerCase());
    let excludeColumns = [];
    if (!this.canVisualize) excludeColumns = ['grade'];

    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns,
    };

    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns,
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableConfig = { header, dataset };
  }
}
